import useFetchedData from 'hooks/useFetchedData'
import { UpdateForm } from '../hooks/useForm'
import Loader from 'components/Loader'
import * as urls from 'api/urls'
import React from 'react'

interface HaveCodeProps {
  setView: (v: string) => void
  updateForm: UpdateForm
}

const HaveCode: React.FC<HaveCodeProps> = ({ setView, updateForm }) => {
  const { data, isLoading } = useFetchedData<board.BoardsListResponse>(urls.boardslist)

  return (
    <div className='haveCode'>
      <div className="haveCode__content">
        <div className='infoLabel'>
          Zeskanuj swoją tabliczkę lub wybierz z listy
        </div>
        <button
          className="btn btn--primary"
          onClick={() => {
            setView('qrScanner')
          }}>
          <i className="icon icon--qr-code"></i>
          Włącz skaner QR
        </button>
        <h2>Wybierz z listy</h2>
        <div className="haveCode__list">
          {isLoading ? (
            <Loader type='full' />
          ) : (
            data && Object.keys(data.myBoards).map((boardId) => {
              const boards = data.myBoards[boardId]
              if (boards.length === 1) {
                return (
                  <div
                    key={boardId}
                    className="listItem"
                    onClick={() => {
                      setView('addWithQrView')
                      updateForm(boards[0].is_empty
                        ? { qrId: boards[0].id, updateProfile: true }
                        : { qrId: boardId })
                    }}>
                    {boards[0].img_thumbnail
                      ? <img src={boards[0].img_thumbnail} alt={boards[0].name} />
                      : <div className='placeholder'><i className="icon icon--cross"></i></div>}
                    <h2>{boards[0].name}</h2>
                    <div className="iconWrap"><i className="icon icon--add"></i></div>
                  </div>
                )
              }
              else {
                return (
                  <div
                    key={boardId}
                    className="listItem listItem--group"
                    onClick={() => {
                      setView('addWithQrView')
                      const emptyBoard = boards.find(board => board.is_empty)
                      updateForm(emptyBoard
                        ? { qrId: emptyBoard.id, updateProfile: true }
                        : { qrId: boardId })
                    }}>
                    <div className="list">
                      {boards.map(board => (
                        <div key={board.id} className="row">
                          {board.img_thumbnail
                            ? <img src={board.img_thumbnail} alt={board.name} />
                            : <div className='placeholder'><i className="icon icon--cross"></i></div>}
                          <h2>{board.name}</h2>
                        </div>
                      ))}
                    </div>
                    <div className="iconWrap"><i className="icon icon--add"></i></div>
                  </div>
                )
              }
            })
          )}
        </div>
      </div>
    </div>
  )
}

export default HaveCode 